import { render, staticRenderFns } from "./CommunityCalendarEvent.vue?vue&type=template&id=6b4996c2&scoped=true&"
import script from "./CommunityCalendarEvent.vue?vue&type=script&lang=js&"
export * from "./CommunityCalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCalendarEvent.vue?vue&type=style&index=0&id=6b4996c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4996c2",
  null
  
)

export default component.exports